/**
 * @description
 */
export default function noZero(value) {
    return 0 != value || 'Debe ser distinto de cero.'
}
